import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SubscriptionBanner = ({ subscription }) => {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed || subscription.status === 'active') {
    return null;
  }

  const getBannerColor = (status) => {
    const colors = {
      'expiring': 'bg-warning/10 border-warning/20 text-warning-foreground',
      'expired': 'bg-error/10 border-error/20 text-error-foreground',
      'trial': 'bg-primary/10 border-primary/20 text-primary-foreground'
    };
    return colors[status] || colors.trial;
  };

  const getIcon = (status) => {
    const icons = {
      'expiring': 'Clock',
      'expired': 'AlertCircle',
      'trial': 'Info'
    };
    return icons[status] || 'Info';
  };

  const getMessage = (status, daysLeft) => {
    const messages = {
      'expiring': `Your subscription expires in ${daysLeft} days. Renew now to avoid service interruption.`,
      'expired': 'Your subscription has expired. Renew now to restore full access to all features.',
      'trial': `You have ${daysLeft} days left in your trial. Upgrade to continue using all features.`
    };
    return messages[status] || messages.trial;
  };

  return (
    <div className={`border rounded-lg p-4 mb-6 ${getBannerColor(subscription.status)}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Icon name={getIcon(subscription.status)} size={20} />
          <div>
            <p className="font-medium">
              {subscription.status === 'expired' ? 'Subscription Expired' : 
               subscription.status === 'expiring' ? 'Subscription Expiring' : 'Trial Period'}
            </p>
            <p className="text-sm opacity-90">
              {getMessage(subscription.status, subscription.daysLeft)}
            </p>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          <Button
            variant={subscription.status === 'expired' ? 'default' : 'outline'}
            size="sm"
            iconName="CreditCard"
            iconPosition="left"
          >
            {subscription.status === 'expired' ? 'Renew Now' : 'Upgrade'}
          </Button>
          
          {subscription.status !== 'expired' && (
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsDismissed(true)}
              iconName="X"
              iconSize={16}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionBanner;